import type { GridValidRowModel } from '@mui/x-data-grid';
import { FC } from 'react';
import type { DataGridProProps as DataGridProps, GridApiPro, GridColDef } from '@mui/x-data-grid-pro';

export const VY_TABLE_FUNCTIONAL_COLUMNS = Object.freeze({
  PREFIX: 'prefix',
} satisfies Record<string, string>);

export type VyTableFunctionalColumns =
  (typeof VY_TABLE_FUNCTIONAL_COLUMNS)[keyof typeof VY_TABLE_FUNCTIONAL_COLUMNS];

export const VY_TABLE_FUNCTIONAL_COLUMNS_KEYS = Object.values(VY_TABLE_FUNCTIONAL_COLUMNS);

export type VyTableProps<Item extends Omit<GridValidRowModel, 'rows'>> = {
  itemsCount: number;
  items: Item[];
  loadingItems?: boolean;
  columns: GridColDef<Item>[];
  showPagination?: boolean;
  paginationClassName?: string;
  fadeOverlay?: boolean;
  sortingMode?: 'client' | 'server';
  emptyTableMessageSize?: number;
  useColumnVisibility?: boolean;
  checkboxVisibleOnHover?: boolean;
  rowsPerPageOptions?: number[];
  noRowsOverlay?: FC;
  page?: number;
  pageSize?: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
  tableName: string;
  apiRef?: React.MutableRefObject<GridApiPro | null>;
  tableColumnsApiConfig?: { visibility?: Record<string, boolean> };
} & Omit<DataGridProps<Item>, 'rows' | 'columns'>;

export type VyTableMinimalProps<Item extends Omit<GridValidRowModel, 'rows'>> = Omit<
  VyTableProps<Item>,
  'rows' | 'columns'
>;
